
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staking/lido/withdrawal",
      function () {
        return require("private-next-pages/staking/lido/withdrawal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staking/lido/withdrawal"])
      });
    }
  